import { motion } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";
import Images from "../../assets/images/index";
import Reveal from "../../components/Reveal";
import TiltCard from "../../components/TiltCard";
import Counter from "../../components/Counter";

const stats = [
  { to: 6, suffix: "+", label: "Years Experience", color: "text-content" },
  { to: 15, suffix: "+", label: "Happy Clients", color: "text-content" },
  { to: 20, suffix: "+", label: "Projects Shipped", color: "text-content" },
];

const About = () => {
  return (
    <section id="about" className="relative px-6 py-28 md:py-36">
      <div className="container mx-auto max-w-6xl">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          {/* portrait */}
          <Reveal direction="right">
            <div className="relative mx-auto max-w-sm">
              <div className="absolute -inset-5 rounded-[2.2rem] bg-gradient-to-tr from-aurora-violet/30 via-aurora-indigo/20 to-aurora-pink/30 blur-2xl animate-pulse-glow" />
              <div className="ring-aurora glass-strong relative overflow-hidden rounded-[2rem] p-2">
                <img
                  src={Images.Shahed}
                  alt="Shahed Talukder"
                  className="h-[26rem] w-full rounded-[1.6rem] object-cover object-top"
                />
                <div className="pointer-events-none absolute inset-2 rounded-[1.6rem] bg-gradient-to-t from-black/40 via-transparent to-transparent" />
              </div>

              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                className="glass absolute -bottom-6 -left-6 rounded-2xl px-5 py-3"
              >
                <p className="text-2xl font-bold text-gradient">6+ yrs</p>
                <p className="text-xs text-muted">crafting the web</p>
              </motion.div>

              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                className="glass absolute -right-5 top-8 rounded-2xl px-4 py-3"
              >
                <p className="text-xs font-medium text-emerald-400">● Open to work</p>
              </motion.div>
            </div>
          </Reveal>

          {/* copy */}
          <div>
            <Reveal direction="left">
              <span className="inline-flex items-center gap-2 rounded-full border border-hairline bg-fill px-4 py-1.5 text-xs font-medium uppercase tracking-[0.28em] text-content backdrop-blur-md">
                <span className="h-1.5 w-1.5 rounded-full bg-content animate-pulse-glow" />
                About me
              </span>
            </Reveal>

            <Reveal direction="left" delay={0.05}>
              <h2 className="mt-6 text-4xl font-bold leading-tight tracking-tight md:text-5xl">
                Turning complex ideas into{" "}
                <span className="text-gradient">elegant, living products</span>
              </h2>
            </Reveal>

            <Reveal direction="left" delay={0.1}>
              <p className="mt-6 text-lg leading-relaxed text-muted">
                I'm a full-stack software engineer with 6+ years across web and
                mobile — building scalable, secure products with React, Spring
                Boot, Node.js and FastAPI. I've led a small team, shipped
                microservices platforms for enterprise and government clients,
                and bring genuine Identity &amp; Access Management depth to
                everything I build.
              </p>
            </Reveal>

            <div className="mt-10 grid grid-cols-3 gap-4">
              {stats.map((s, i) => (
                <Reveal key={s.label} direction="up" delay={0.15 + i * 0.1}>
                  <TiltCard className="glass rounded-2xl p-5 text-center">
                    <p className={`text-3xl font-bold md:text-4xl ${s.color}`}>
                      <Counter to={s.to} suffix={s.suffix} />
                    </p>
                    <p className="mt-1 text-xs text-muted md:text-sm">
                      {s.label}
                    </p>
                  </TiltCard>
                </Reveal>
              ))}
            </div>

            <Reveal direction="left" delay={0.4}>
              <a
                href="#contact"
                className="group mt-10 inline-flex items-center gap-2 font-semibold text-content transition-colors hover:text-content"
              >
                Let's build something together
                <FiArrowUpRight className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
